import {
  GET_ARCHIVED_MATCHES,
  GET_LIVE_MATCHES,
  GET_UPCOMING_MATCHES,
  GET_MATCH_PLAYERS,
  GET_MATCH_SESSIONS,
  GET_SESSION_SEAT_DRAW,
  GET_PUBLIC_INFO,
} from 'constants/actionTypes';

const defaultState = {
  liveMatches: [],
  upcomingMatches: [],
  archivedMatches: [],
  players: [],
  sessions: [],
  seatDraw: [],
  playersPublicInfo: [],
};

function matchesReducer(state = defaultState, action) {
  switch (action.type) {
    case GET_LIVE_MATCHES: {
      const list = action.payload;
      return {
        ...state,
        liveMatches: list,
      };
    }
    case GET_UPCOMING_MATCHES: {
      const list = action.payload;
      return {
        ...state,
        upcomingMatches: list,
      };
    }
    case GET_ARCHIVED_MATCHES: {
      const list = action.payload;
      return {
        ...state,
        archivedMatches: list,
      };
    }
    case GET_MATCH_PLAYERS: {
      return {
        ...state,
        players: action.payload,
      };
    }
    case GET_MATCH_SESSIONS: {
      return {
        ...state,
        sessions: action.payload,
      };
    }
    case GET_SESSION_SEAT_DRAW: {
      return {
        ...state,
        seatDraw: action.payload,
      };
    }
    case GET_PUBLIC_INFO: {
      return {
        ...state,
        playersPublicInfo: action.payload,
      };
    }
    default:
      return state;
  }
}

export default matchesReducer;
